import React from 'react';
import SEO from '../components/SEO';
import ServiceLayout from '../components/ServiceLayout';

const ConsultingPage: React.FC = () => {
  return (
    <>
      <SEO
        title="Site Assessment & Planning"
        description="Comprehensive site assessments and project planning for healthcare equipment installations — coordinating with IT, facilities, and clinical teams."
        keywords="hospital site assessment, healthcare equipment planning, clinical facility evaluation, medical installation planning"
        url="https://www.jvphealthtechsolutions.com/services/consulting"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Site Assessment & Planning",
          "description": "Comprehensive site assessments and project planning for healthcare equipment installations.",
          "provider": { "@type": "Organization", "name": "JVP Health Tech Solutions" },
          "areaServed": "US"
        }}
      />
      <ServiceLayout
        title="Site Assessment & Planning"
        subtitle="Every great install starts with a plan — we make sure yours is airtight."
        pageImage="/images/services/planning-f9555133.jpg"
        pageImageAlt="Site assessment and planning for hospital equipment"
        ctaText="Schedule Assessment"
        summary="Before a single mount goes on the wall, we walk your facility with the people who know it best — your IT, facilities, and clinical teams. Together, we map out exactly what's needed so there are no surprises on install day."
        sections={[
          {
            title: 'What We Evaluate',
            body: 'Our assessment covers every detail that affects your installation — from structural feasibility to day-to-day workflow.',
            items: [
              'Ceiling and wall structures — can they support the equipment you need?',
              'Power and data drops — are they where they need to be?',
              'How your teams actually move through the space',
              'ADA and Joint Commission requirements — built into the plan from the start',
              'Construction timelines — we coordinate with your GC to stay on schedule',
              'Equipment compatibility with your existing infrastructure',
            ],
          },
          {
            title: 'How It Works',
            body: 'A straightforward process designed to give you a clear, actionable plan — whether it\'s one department or a hundred rooms across ten sites.',
            items: [
              'Kickoff call to align on goals, scope, and timeline',
              'On-site walkthrough with your key stakeholders',
              'Detailed assessment report — mounting locations, infrastructure needs, and our recommendations',
              'Project plan you can hand to anyone on your team and they\'ll know exactly what\'s happening',
            ],
          },
        ]}
      />
    </>
  );
};

export default ConsultingPage;
